// composables/useKooi.js
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useKooiNavigation } from '../../pinia/KooiNavigation';
import { useRoute, useRouter } from 'vue-router'
import { internalVat, useInternalCompany } from '../../helpers/useInternalCompany';
import {
    kooiFrontendSettings,
    stockFrontend,
    purchaseFrontend,
    directFrontend,
    provisionFrontend,
    rebateFrontend,
    GrStockFrontend,
    GrDirectTrustFrontend,
    GrStockTrustFrontend,
    GrCommissionOnlyFrontend,
    GrDirectFrontend,
} from './frontendSettings/KooiFrontendClass';
import moment from 'moment';
import { MgDirectFrontendSettings, MgFrontendSettings, MgProvisionFrontendSettings, MgPurchaseFrontendSettings, MgStockFrontendSettings } from './frontendSettings/MgFrontendClass';


export function useIsDisabled() {
    const store = useStore();
    const policies = computed(() => {
        return store.state.kooi.policies
    });
    const updateDisabled = computed(() => {
        return !store.state.kooi.policies.update;
    });
    return {
        updateDisabled,
        policies
    };
}

export function useIsConsignmentStock() {
    const store = useStore();
    const isConsignmentStock = computed(() => {
        if (store.state.kooi?.supplier?.settings && 'consingment_stock' in store.state.kooi.supplier.settings && store.state.kooi.supplier.settings.consingment_stock == true) {
            return true;
        }
        return false;
    })
    return { isConsignmentStock };
}
export function kooiStatus(){
    const store = useStore();
    return computed(() => {
        return store.state.kooi.kooi.status;
    });
}

export function useKooiTypes() {
    const store = useStore();

    const type_purchase = computed(() => {
        return store.state.kooi?.kooi?.sales_type == "purchase";
    });
    const type_stock_sale = computed(() => {
        return store.state.kooi?.kooi?.sales_type == "stock" || store.state.kooi?.kooi?.sales_type == "stock_trust";
    });
    const type_provision = computed(() => {
        return store.state.kooi?.kooi?.sales_type == "provision";
    });
    const type_direct = computed(() => {
        return store.state.kooi?.kooi?.sales_type == "direct";
    });
    const type_direct_trust = computed(() => {
        return store.state.kooi?.kooi?.sales_type == "direct_trust";
    });
    const type_rebate = computed(() => {
        return store.state.kooi?.kooi?.sales_type == "rebate";
    });
    const type_commission_only = computed(() => {
        return store.state.kooi?.kooi?.sales_type == "commission_only";
    })
    const frontend_settings = computed(() => {

        if(store.state.kooi.kooi.internal_company_id == 3){

            if (type_stock_sale.value == true) {
                return new MgStockFrontendSettings();
            }
            if(type_direct.value == true){
                return new MgDirectFrontendSettings
            }
            if (type_purchase.value == true) {
                return new MgPurchaseFrontendSettings();
            }
            if (type_provision.value == true) {
                return new MgProvisionFrontendSettings();
            }
            return new MgFrontendSettings;
        }

        if (type_purchase.value == true) {
            return new purchaseFrontend();
        }

        if( store.state.kooi.kooi.internal_company_id == 4){
            if (type_stock_sale.value == true) {
                return new GrStockTrustFrontend();
            }
            if (type_stock_sale.value == true ) {
                return new GrStockFrontend();
            }
            if(type_commission_only.value == true ){
                return new GrCommissionOnlyFrontend();
            }
            if(type_direct_trust.value == true){
                return new GrDirectTrustFrontend();
            }
            if(type_direct.value == true){
                return new GrDirectFrontend
            }
        }


        if (type_stock_sale.value == true) {
            return new stockFrontend();
        }


        if (type_provision.value == true) {
            return new provisionFrontend();
        }

        if (type_direct.value == true) {
            return new directFrontend();
        }
        if (type_rebate.value == true) {
            return new rebateFrontend();
        }
        return new kooiFrontendSettings();
    })
    return {
        type_stock_sale,
        type_purchase,
        type_provision,
        type_direct,
        type_direct_trust,
        frontend_settings,
        type_commission_only,
    };
}

export function useKooiSalesType() {
    const store = useStore();
    const kooi_sales_type = computed(() => { return store.state.kooi.kooi.sales_type });
    return kooi_sales_type;
}
export function usePossibleTabs() {
    const kooiNavigation = useKooiNavigation();

    const possibleTabs = computed(() => {
        return kooiNavigation.posible_tabs.filter((item) => !item.filter || item.filter.includes(useKooiSalesType()))
    });


    return {
        possibleTabs
    };
}
export function checkTabOrRedirect() {
    const route = useRoute();
    const router = useRouter();
    const { possibleTabs } = usePossibleTabs(useKooiSalesType());
    var index = possibleTabs.value.findIndex(item => "kooi." + item.key == route.name);
    if (index <= -1) {
        var originalParams = route.params;
        originalParams.type = possibleTabs.value[0].subkey;
        router.push({ name: 'kooi.' + possibleTabs.value[0].key, params: originalParams });
    }

}


export function getBusinessType() {
    const store = useStore();
    const business_type = computed(() => {
        return store.state.kooi?.kooi?.sales_type;
    });
    return business_type;
}


export function getExportInnerBusiness() {
  const store = useStore();
  const  internal_vat = internalVat();
  let business_type = getBusinessType();
  let {frontend_settings} = useKooiTypes();
  let internalVatPart = internal_vat.value.trim().substr(0,2);

  let companyVat = {};
  if (business_type == "purchase") {
    companyVat = store.state.kooi?.supplier?.settings?.vat ?? "";
  } else {
    companyVat = store.state.kooi?.customer?.settings?.vat ?? "";
    console.log(frontend_settings.value.overwrite_internal_with_supplier_tax);
    if(frontend_settings.value.overwrite_internal_with_supplier_tax === true){
        console.log("vat",  store.state.kooi?.supplier?.settings?.vat)
        internalVatPart = store.state.kooi?.supplier?.settings?.vat?.trim().substr(0,2) ?? "";
      }
  }

    let companyVatPart  = companyVat.trim().substr(0, 2);
    if(companyVatPart == "" || internalVatPart == ""){
        return "export";
    }
  if (companyVatPart != internalVatPart) {
    return "export";
  }
  return "inner";
}

export function logisticsInfos(){
    const store = useStore();
    const lockLogistics = computed(() => {
        return store.state.kooi.lockLogistics;
    });
    return {
        lockLogistics
    };
}
export function getSupplierExportInnerBusiness() {
    const store = useStore();
    const  internal_vat = internalVat();
    let companyVat = store.state.kooi?.supplier?.settings?.vat ?? "";

    let companyVatPart  = companyVat.trim().substr(0, 2);
    let internalVatPart = internal_vat.value.trim().substr(0,2);

    if(companyVatPart == "" || internalVatPart == ""){
            return "export";
    }
    if (companyVatPart != internalVatPart) {
      return "export";
    }
    return "inner";
  }


export function useInvMInvCDiffMonths(){
    const store = useStore();
    const invm_c_diff_months = computed(() => {
        let invoice = store.state.kooi.tables.invoices.filter(item => item.type == "Invoice" && item.canceled_by == null);
        let compareDate;
        if(invoice && invoice[0]){
            compareDate = moment(invoice[0].invoice_date);
            compareDate.hour(12).minute(0).second(0);
        }else{
            compareDate = moment();
            compareDate.hour(12).minute(0).second(0);
        }
        compareDate = compareDate.date(1);
        if(store.state?.kooi?.kooi?.data?.order_conformation &&
            store.state?.kooi?.kooi?.data?.order_conformation[0] &&
            store.state?.kooi?.kooi?.data?.order_conformation[0].invoice_dates
        ){
            let dates = store.state?.kooi?.kooi?.data?.order_conformation[0].invoice_dates.split(",");
            for(let date in dates){
                let invm = moment(dates[date]);
                invm.date(1).hour(12).minute(0).second(0);;
                if(invm.isBefore(compareDate) || invm.isAfter(compareDate)){
                    return true;
                }
            }
        }
        return false;
        })
    return invm_c_diff_months;
}

export function useLogisticCompanies(){
    const store = useStore();
    const chainSelectedCompanies = computed(() => {
        let tmp = [];
        if(store.state.kooi.logistics.list && store.state.kooi.logistics.list.length > 0){
            let blocks = store.state.kooi.logistics.list;
            if(store.state.kooi?.kooi.data?.company?.id && store.state.kooi?.kooi.data?.company?.id != 0){
                let index = tmp.findIndex(item => item.id == store.state.kooi?.kooi.data?.company.id )
                if(index < 0){
                    tmp.push(store.state.kooi?.kooi.data?.company);
                }
            }
            if(store.state.kooi?.kooi.data?.supplier?.id && store.state.kooi?.kooi.data?.supplier?.id != 0){
                let index = tmp.findIndex(item => item.id == store.state.kooi?.kooi.data?.supplier.id )
                if(index < 0){
                    tmp.push(store.state.kooi?.kooi.data?.supplier);
                }
            }
            for(let i in blocks){
                for(let j in blocks[i].blocks){
                    if(blocks[i].blocks[j].data?.company?.id){
                        let index = tmp.findIndex(item => item.id == blocks[i].blocks[j].data?.company?.id)
                        if(index < 0){
                            tmp.push(blocks[i].blocks[j].data?.company);
                        }
                    }
                }
            }
        }
        return tmp;
    })
    return chainSelectedCompanies
}


export function useInDocumentWarnings(){
        const store = useStore();
    const inDocumentWarnings = computed(() => {
        let tmp  = [];
            const internal_vat = internalVat();
            if(internal_vat.value.trim() == ""){
                tmp.push('labels.pdf.validation.internal_company_no_vat');
            }
            let supplierVat = store.state.kooi?.supplier?.settings?.vat ?? "";
            if(store.state.kooi.supplier?.id &&
                supplierVat.trim() == ""){
                tmp.push('labels.pdf.validation.supplier_no_vat');
            }
            let companyVat = store.state.kooi?.customer?.settings?.vat ?? "";
             if(store.state.kooi.customer?.id &&
                companyVat.trim() == ""){
                tmp.push('labels.pdf.validation.customer_no_vat');
             }
        return tmp;
    });


    return inDocumentWarnings;

}

export const isPartialShipmentKooi = () => {
    const store = useStore();
    return computed(() => {
        return store?.state?.kooi?.kooi?.data?.flag_partial_shipment;
    })
}



export const useImperialMetricOptions = () => {
    return computed(() => {
        return [
            {
                value: 'imperial',
                name: 'Imperial',
            },
            {
                value: 'metric',
                name: 'Metric',
            }
        ]
    })
}

export const useImperialMetricSetting = () => {
    const route = useRoute();
    const store = useStore();

    const imperialMetricSetting = computed(() =>{
            if(["orders", "invoices"].includes(route.params.type)){
                return store.state.kooi.kooi.data.customer_imperial_metric;
            }else{
                return store.state.kooi.kooi.data.supplier_imperial_metric;
            }
        });
        return {
            imperialMetricSetting,
        };
}

export function refreshInvoiceFooter(invoice){
    console.log("refresh invoice footer", JSON.parse(JSON.stringify(invoice)));
    const {internal_company}  = useInternalCompany();
    if('footer' in invoice){
        invoice.footer = null;
        invoice.footer = Object.assign({},
            internal_company.value.informations.footer
        );
    }
    if('data' in invoice && 'footer' in invoice.data){
        invoice.data.footer = null;
        invoice.data.footer = Object.assign({},
            internal_company.value.informations.footer
        );
    }
    return invoice;

}
